// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120505/js/" + chunkId + "." + {"44":"46e9f852","225":"e0635ecc","481":"205ac7b8","486":"b51cf426","770":"1f6bc570"}[chunkId] + ".0.6233396940822956.chunk.js";
};